<template>
  <div class="preview" id="js-preview" ref="canvas">
    <!-- シャツ - 前面 -->
    <div
      class="preview__item preview__item--shirtsFront"
      @click="setTab('shirts')"
    >
      <!-- 全体 -->
      <ShirtsFrontOverallItemImage
        v-if="selectedOverallItem.id"
        :type="selectedOverallItem.slug"
        :color="selectedOverallItemSingleColor || 'transparent'"
        :startColor="selectedOverallItemGradationStartColor"
        :endColor="selectedOverallItemGradationEndColor"
        :stripeColor="selectedOverallItemStripeColor"
      />
      <img
        v-if="selectedOverallItem.slug === 'pattern' && selectedOverallItemTexture"
        :src="`${ selectedOverallItemTexture }-front.svg`"
      />
      <ShirtsFrontBaseItemImage v-if="current === 'shirts'" />
      <!-- 胴 - 胴 -->
      <ItemShirtsBodyMainFront
        v-if="selectedBodyMainItem.id"
        :name="selectedBodyMainItem.slug"
        :color="selectedBodyMainItemColor"
        :texture="selectedBodyMainItemTexture"
      />
      <!-- 胴 - 脇 -->
      <ItemShirtsBodySideFront
        v-if="selectedBodySideItem.id"
        :name="selectedBodySideItem.slug"
        :color="selectedBodySideItemColor"
        :color2="selectedBodySideItemColor2"
        :texture="selectedBodySideItemTexture"
      />
      <!-- 腕 - 肩パーツ -->
      <ItemShirtsArmShoulderPartFront
        v-if="selectedArmShoulderPartItem.id"
        :name="selectedArmShoulderPartItem.slug"
        :color="selectedArmShoulderPartItemColor"
      />
      <!-- 腕 - 腕パーツ -->
      <ItemShirtsArmArmPartFront
        v-if="selectedArmArmPartItem.id"
        :name="selectedArmArmPartItem.slug"
        :color="selectedArmArmPartItemColor"
        :color2="selectedArmArmPartItemColor2"
      />
      <!-- 腕 - 袖パーツ -->
      <ItemShirtsArmSleevePartFront
        v-if="selectedArmSleevePartItem.id"
        :name="selectedArmSleevePartItem.slug"
        :color="selectedArmSleevePartItemColor"
        :color2="selectedArmSleevePartItemColor2"
      />
      <!-- 腕 - 袖ライン -->
      <ItemShirtsArmSleeveLineFront
        v-if="selectedArmSleeveLineItem.id"
        :name="selectedArmSleeveLineItem.slug"
        :color="selectedArmSleeveLineItemColor"
        :color2="selectedArmSleeveLineItemColor2"
        :color3="selectedArmSleeveLineItemColor3"
      />
      <!-- 襟ライン -->
      <ItemShirtsCollarFront
        v-if="selectedCollarItem.id"
        :name="selectedCollarItem.slug"
        :color="selectedCollarItemColor"
        :color2="selectedCollarItemColor2"
        :color3="selectedCollarItemColor3"
      />
      <!-- 全体（ステッチ用に1番上にのせる） -->
      <ShirtsFrontOverallItemImage type="single_color" color="transparent" />
      <!-- エンブレム -->
      <div :class="`preview__item__emblemFront ${ selectedEmblemImage && 'is-selected' }`">
        <img v-if="selectedEmblemImage" :src="selectedEmblemImage.image_url" alt="">
      </div>
      <!-- マーク - 胸 - マーク - 両側 -->
      <div :class="`preview__item__markChestBothSides ${ selectedMarkChest.slug && 'is-selected' }`">
        <MarkChestBothSidesItemImage
          :name="selectedMarkChest.slug"
          :color1="selectedMarkChestColor1"
          :color2="selectedMarkChestColor2"
          :color3="selectedMarkChestColor3"
        />
      </div>
      <!-- マーク - 胸 - マーク- 片側 -->
      <div class="preview__item__markChestOneSide">
        <MarkChestOneSideItemImage
          :name="selectedMarkChest.slug"
          :color1="selectedMarkChestColor1"
          :color2="selectedMarkChestColor2"
          :color3="selectedMarkChestColor3"
        />
      </div>
      <!-- マーク - 胸 - 番号 -->
      <div class="preview__item__markChestNumber">
        <MarkNumberItemImage
          :name="selectedMarkChestNumber.slug"
          :color1="selectedMarkChestNumberColor1"
        />
      </div>
      <!-- マーク - 袖 -->
      <div class="preview__item__markSleeveFront">
        <MarkSleeveJapaneseItemImage
          :name="selectedMarkSleeve.slug"
          :color1="selectedMarkSleeveColor1"
        />
        <MarkSleeveEnglishItemImage
          :name="selectedMarkSleeve.slug"
          :color1="selectedMarkSleeveColor1"
        />
      </div>
    </div>
    <!-- シャツ - 背面 -->
    <div
      :class="`preview__item preview__item--shirtsBack ${ selectedMarkBack.slug && 'is-selected' }`"
      @click="setTab('shirts')"
    >
      <!-- 全体 -->
      <ShirtsBackOverallItemImage
        v-if="selectedOverallItem.id"
        :active="current === 'shirts'"
        :type="selectedOverallItem.slug"
        :color="selectedOverallItemSingleColor"
        :startColor="selectedOverallItemGradationStartColor"
        :endColor="selectedOverallItemGradationEndColor"
        :stripeColor="selectedOverallItemStripeColor"
      />
      <img
        v-if="selectedOverallItem.slug === 'pattern' && selectedOverallItemTexture"
        :src="`${ selectedOverallItemTexture }-back.svg`"
      />
      <ShirtsBackBaseItemImage v-if="current === 'shirts'" />
      <!-- 胴 - 胴 -->
      <ItemShirtsBodyMainBack
        v-if="selectedBodyMainItem.id"
        :name="selectedBodyMainItem.slug"
        :color="selectedBodyMainItemColor"
        :texture="selectedBodyMainItemTexture"
      />
      <!-- 胴 - 脇 -->
      <ItemShirtsBodySideBack
        v-if="selectedBodySideItem.id"
        :name="selectedBodySideItem.slug"
        :color="selectedBodySideItemColor"
        :color2="selectedBodySideItemColor2"
        :texture="selectedBodySideItemTexture"
      />
      <!-- 腕 - 肩パーツ -->
      <ItemShirtsArmShoulderPartBack
        v-if="selectedArmShoulderPartItem.id"
        :name="selectedArmShoulderPartItem.slug"
        :color="selectedArmShoulderPartItemColor"
      />
      <!-- 腕 - 腕パーツ -->
      <ItemShirtsArmArmPartBack
        v-if="selectedArmArmPartItem.id"
        :name="selectedArmArmPartItem.slug"
        :color="selectedArmArmPartItemColor"
        :color2="selectedArmArmPartItemColor2"
      />
      <!-- 腕 - 袖パーツ -->
      <ItemShirtsArmSleevePartBack
        v-if="selectedArmSleevePartItem.id"
        :name="selectedArmSleevePartItem.slug"
        :color="selectedArmSleevePartItemColor"
        :color2="selectedArmSleevePartItemColor2"
      />
      <!-- 腕 - 袖ライン -->
      <ItemShirtsArmSleeveLineBack
        v-if="selectedArmSleeveLineItem.id"
        :name="selectedArmSleeveLineItem.slug"
        :color="selectedArmSleeveLineItemColor"
        :color2="selectedArmSleeveLineItemColor2"
        :color3="selectedArmSleeveLineItemColor3"
      />
      <!-- 襟ライン -->
      <ItemShirtsCollarBack
        v-if="selectedCollarItem.id"
        :name="selectedCollarItem.slug"
        :color="selectedCollarItemColor"
        :color2="selectedCollarItemColor2"
        :color3="selectedCollarItemColor3"
      />
      <!-- 全体（ステッチ用に1番上にのせる） -->
      <ShirtsBackOverallItemImage type="single_color" />
      <!-- エンブレム -->
      <div :class="`preview__item__emblemBack ${ selectedEmblemImage && 'is-selected' }`">
        <img v-if="selectedEmblemImage" :src="selectedEmblemImage.image_url" alt="">
      </div>
      <!-- マーク -->
      <div :class="`preview__item__markBackNumber ${ selectedMarkBackNumber.slug && 'is-selected' }`">
        <MarkNumberItemImage v-if="selectedMarkBackNumber.slug" :name="selectedMarkBackNumber.slug" :color1="selectedMarkBackNumberColor1" />
      </div>
      <div v-if="selectedMarkBack.slug" class="preview__item__markBackName">
        <MarkBackNameItemImage :name="selectedMarkBack.slug" :color1="selectedMarkBackColor1" />
      </div>
      <!-- マーク - 袖 -->
      <div class="preview__item__markSleeveBack">
        <MarkSleeveJapaneseItemImage
          :name="selectedMarkSleeve.slug"
          :color1="selectedMarkSleeveColor1"
        />
        <MarkSleeveEnglishItemImage
          :name="selectedMarkSleeve.slug"
          :color1="selectedMarkSleeveColor1"
        />
      </div>
    </div>
    <!-- キャップ - 前面（アーチ） -->
    <div
      v-show="selectedCapVisorFormItem.slug === 'visor_form_arch'"
      class="preview__item preview__item--capFront"
      @click="setTab('cap')"
    >
      <img
        v-if="selectedCapVisorFormItemType === 'texture' && selectedCapVisorFormItemTexture"
        :src="`/simulator/images/cap/texture_arch_${ selectedCapVisorFormItemTexture }.svg`"
        alt=""
      >
      <CapBaseItemImage
        :name="selectedCapVisorFormItem.slug"
        :active="current === 'cap'"
        :visorLineItemColor="selectedCapVisorLineItemColor"
        :visorFormItemColor="selectedCapVisorFormItemColor"
        :crownFrontColor="selectedCapCrownFrontColor"
        :crownBackColor="selectedCapCrownBackColor"
        :crownButtonColor="selectedCapCrownButtonColor"
        :crownHoleColor="selectedCapCrownHoleColor"
      />
      <div class="preview__item__capMark">
        <CapMarkItemImage
          :name="selectedCapMark.slug"
          :color1="selectedCapMarkColor1"
          :color2="selectedCapMarkColor2"
          :color3="selectedCapMarkColor3"
        />
      </div>
    </div>
    <!-- キャップ - 前面（平ツバ） -->
    <div
      v-show="selectedCapVisorFormItem.slug === 'visor_form_flat'"
      class="preview__item preview__item--capFront"
      @click="setTab('cap')"
    >
      <img
        v-if="selectedCapVisorFormItemType === 'texture' && selectedCapVisorFormItemTexture"
        :src="`/simulator/images/cap/texture_flat_${ selectedCapVisorFormItemTexture }.svg`"
        alt=""
      >
      <CapBaseItemImage
        :name="selectedCapVisorFormItem.slug"
        :active="current === 'cap'"
        :visorLineItemColor="selectedCapVisorLineItemColor"
        :visorFormItemColor="selectedCapVisorFormItemColor"
        :crownFrontColor="selectedCapCrownFrontColor"
        :crownBackColor="selectedCapCrownBackColor"
        :crownButtonColor="selectedCapCrownButtonColor"
        :crownHoleColor="selectedCapCrownHoleColor"
      />
      <div class="preview__item__capMark">
        <CapMarkItemImage
          :name="selectedCapMark.slug"
          :color1="selectedCapMarkColor1"
          :color2="selectedCapMarkColor2"
          :color3="selectedCapMarkColor3"
        />
      </div>
    </div>
    <!-- キャップ - 背面 -->
    <div
      class="preview__item preview__item--capBack"
      @click="setTab('cap')"
    >
      <CapBaseItemImage
        name="visor_form_back"
        :active="current === 'cap'"
        :visorLineItemColor="selectedCapVisorLineItemColor"
        :visorFormItemColor="selectedCapVisorFormItemColor"
        :crownFrontColor="selectedCapCrownFrontColor"
        :crownBackColor="selectedCapCrownBackColor"
        :crownButtonColor="selectedCapCrownButtonColor"
        :crownHoleColor="selectedCapCrownHoleColor"
      />
    </div>
    <!-- パンツ -->
    <div
      class="preview__item preview__item--pants"
      @click="setTab('pants')"
    >
      <PantsItemImage
        v-if="selectedPantsBaseItem.slug"
        :active="current === 'pants'"
        :name="selectedPantsBaseItem.slug"
        :color="selectedPantsBaseItem.color"
      />
      <PantsItemImage
        v-if="selectedPantsDecorateItem.slug"
        :active="current === 'pants'"
        :name="selectedPantsDecorateItem.slug"
        :color="selectedPantsDecorateItemColor"
      />
    </div>
    <!-- エンブレム -->
    <div
      :class="`preview__item preview__item--emblem ${ selectedEmblemImage && 'is-selected' }`"
      @click="setTab('emblem')"
    >
      <img v-if="selectedEmblemImage" :src="selectedEmblemImage.image_url" alt="">
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import ShirtsFrontBaseItemImage from './images/item/ShirtsFrontBaseItemImage'
import ShirtsFrontOverallItemImage from './images/item/ShirtsFrontOverallItemImage'
import ShirtsBackBaseItemImage from './images/item/ShirtsBackBaseItemImage'
import ShirtsBackOverallItemImage from './images/item/ShirtsBackOverallItemImage'
import ItemShirtsBodyMainFront from './images/item/shirts/ItemShirtsBodyMainFront'               // シャツ「胴 - 胴」
import ItemShirtsBodyMainBack from './images/item/shirts/ItemShirtsBodyMainBack'                 // シャツ「胴 - 胴」
import ItemShirtsBodySideFront from './images/item/shirts/ItemShirtsBodySideFront'               // シャツ「胴 - 脇」
import ItemShirtsBodySideBack from './images/item/shirts/ItemShirtsBodySideBack'                 // シャツ「胴 - 脇」
import ItemShirtsCollarFront from './images/item/shirts/ItemShirtsCollarFront'                   // シャツ「襟ライン」
import ItemShirtsCollarBack from './images/item/shirts/ItemShirtsCollarBack'                     // シャツ「襟ライン」
import ItemShirtsArmShoulderPartFront from './images/item/shirts/ItemShirtsArmShoulderPartFront' // シャツ「腕 - 肩パーツ」
import ItemShirtsArmShoulderPartBack from './images/item/shirts/ItemShirtsArmShoulderPartBack'   // シャツ「腕 - 肩パーツ」
import ItemShirtsArmArmPartFront from './images/item/shirts/ItemShirtsArmArmPartFront'           // シャツ「腕 - 腕パーツ」
import ItemShirtsArmArmPartBack from './images/item/shirts/ItemShirtsArmArmPartBack'             // シャツ「腕 - 腕パーツ」
import ItemShirtsArmSleevePartFront from './images/item/shirts/ItemShirtsArmSleevePartFront'     // シャツ「腕 - 袖パーツ」
import ItemShirtsArmSleevePartBack from './images/item/shirts/ItemShirtsArmSleevePartBack'       // シャツ「腕 - 袖パーツ」
import ItemShirtsArmSleeveLineFront from './images/item/shirts/ItemShirtsArmSleeveLineFront'     // シャツ「腕 - 袖ライン」
import ItemShirtsArmSleeveLineBack from './images/item/shirts/ItemShirtsArmSleeveLineBack'       // シャツ「腕 - 袖ライン」
import PantsItemImage from './images/item/PantsItemImage'                                        // パンツ
import CapBaseItemImage from './images/item/CapBaseItemImage'                                    // キャップ「バイザー / クラウン」
import CapMarkItemImage from './images/item/CapMarkItemImage'                                    // キャップ「マーク」
import MarkChestBothSidesItemImage from './images/item/MarkChestBothSidesItemImage'              // マーク「胸マーク - 両側」
import MarkChestOneSideItemImage from './images/item/MarkChestOneSideItemImage'                  // マーク「胸マーク - 片側」
import MarkNumberItemImage from './images/item/MarkNumberItemImage'                              // マーク「胸マーク - 胸番号」
import MarkBackNameItemImage from './images/item/MarkBackNameItemImage'                          // マーク「背面 - 背番号」
import MarkSleeveJapaneseItemImage from './images/item/MarkSleeveJapaneseItemImage'              // マーク「袖マーク - 日本語」
import MarkSleeveEnglishItemImage from './images/item/MarkSleeveEnglishItemImage'                // マーク「袖マーク - 英語」

export default {
  data: function () {
    return {
      output: null
    }
  },
  components: {
    ShirtsFrontBaseItemImage,
    ShirtsFrontOverallItemImage,
    ShirtsBackBaseItemImage,
    ShirtsBackOverallItemImage,
    ItemShirtsBodyMainFront,
    ItemShirtsBodyMainBack,
    ItemShirtsBodySideFront,
    ItemShirtsBodySideBack,
    ItemShirtsCollarFront,
    ItemShirtsCollarBack,
    ItemShirtsArmShoulderPartFront,
    ItemShirtsArmShoulderPartBack,
    ItemShirtsArmArmPartFront,
    ItemShirtsArmArmPartBack,
    ItemShirtsArmSleevePartFront,
    ItemShirtsArmSleevePartBack,
    ItemShirtsArmSleeveLineFront,
    ItemShirtsArmSleeveLineBack,
    PantsItemImage,
    CapBaseItemImage,
    CapMarkItemImage,
    MarkChestBothSidesItemImage,
    MarkChestOneSideItemImage,
    MarkNumberItemImage,
    MarkBackNameItemImage,
    MarkSleeveJapaneseItemImage,
    MarkSleeveEnglishItemImage
  },
  computed: {
    ...mapState({
      current: state => state.current.tab,
      selectedOverallItem: state => state.shirts.selectedOverallItem,
      selectedOverallItemSingleColor: state => state.shirts.selectedOverallItemSingleColor,
      selectedOverallItemGradationStartColor: state => state.shirts.selectedOverallItemGradationStartColor,
      selectedOverallItemGradationEndColor: state => state.shirts.selectedOverallItemGradationEndColor,
      selectedOverallItemStripeColor: state => state.shirts.selectedOverallItemStripeColor,
      selectedOverallItemTexture: state => state.shirts.selectedOverallItemTexture,
      selectedBodyMainItem: state => state.shirts.selectedBodyMainItem,
      selectedBodyMainItemColor: state => state.shirts.selectedBodyMainItemColor,
      selectedBodyMainItemTexture: state => state.shirts.selectedBodyMainItemTexture,
      selectedBodySideItem: state => state.shirts.selectedBodySideItem,
      selectedBodySideItemColor: state => state.shirts.selectedBodySideItemColor,
      selectedBodySideItemColor2: state => state.shirts.selectedBodySideItemColor2,
      selectedBodySideItemTexture: state => state.shirts.selectedBodySideItemTexture,
      selectedCollarItem: state => state.shirts.selectedCollarItem,
      selectedCollarItemColor: state => state.shirts.selectedCollarItemColor,
      selectedCollarItemColor2: state => state.shirts.selectedCollarItemColor2,
      selectedCollarItemColor3: state => state.shirts.selectedCollarItemColor3,
      selectedArmShoulderPartItem: state => state.shirts.selectedArmShoulderPartItem,
      selectedArmShoulderPartItemColor: state => state.shirts.selectedArmShoulderPartItemColor,
      selectedArmArmPartItem: state => state.shirts.selectedArmArmPartItem,
      selectedArmArmPartItemColor: state => state.shirts.selectedArmArmPartItemColor,
      selectedArmArmPartItemColor2: state => state.shirts.selectedArmArmPartItemColor2,
      selectedArmSleevePartItem: state => state.shirts.selectedArmSleevePartItem,
      selectedArmSleevePartItemColor: state => state.shirts.selectedArmSleevePartItemColor,
      selectedArmSleevePartItemColor2: state => state.shirts.selectedArmSleevePartItemColor2,
      selectedArmSleeveLineItem: state => state.shirts.selectedArmSleeveLineItem,
      selectedArmSleeveLineItemColor: state => state.shirts.selectedArmSleeveLineItemColor,
      selectedArmSleeveLineItemColor2: state => state.shirts.selectedArmSleeveLineItemColor2,
      selectedArmSleeveLineItemColor3: state => state.shirts.selectedArmSleeveLineItemColor3,
      selectedPantsBaseItem: state => state.pants.selectedBaseItem,
      selectedPantsDecorateItem: state => state.pants.selectedDecorateItem,
      selectedPantsDecorateItemColor: state => state.pants.selectedDecorateItemColor,
      selectedCapElement: state => state.cap.selectedElement,
      selectedCapVisorLineItemColor: state => state.cap.selectedVisorLineItemColor,
      selectedCapVisorFormItem: state => state.cap.selectedVisorFormItem,
      selectedCapVisorFormItemType: state => state.cap.selectedVisorFormItemType,
      selectedCapVisorFormItemTexture: state => state.cap.selectedVisorFormItemTexture,
      selectedCapVisorFormItemColor: state => state.cap.selectedVisorFormItemColor,
      selectedCapCrownFrontColor: state => state.cap.selectedCrownFrontColor,
      selectedCapCrownBackColor: state => state.cap.selectedCrownBackColor,
      selectedCapCrownButtonColor: state => state.cap.selectedCrownButtonColor,
      selectedCapCrownHoleColor: state => state.cap.selectedCrownHoleColor,
      selectedCapMark: state => state.cap.selectedMarkItem,
      selectedCapMarkColor1: state => state.cap.selectedMarkItemColor1,
      selectedCapMarkColor2: state => state.cap.selectedMarkItemColor2,
      selectedCapMarkColor3: state => state.cap.selectedMarkItemColor3,
      emblem: state => state.emblem.data,
      selectedEmblem: state => state.emblem.selectedItem,
      selectedMarkChest: state => state.mark.selectedChestItem,
      selectedMarkChestColor1: state => state.mark.selectedChestItemColor1,
      selectedMarkChestColor2: state => state.mark.selectedChestItemColor2,
      selectedMarkChestColor3: state => state.mark.selectedChestItemColor3,
      selectedMarkChestNumber: state => state.mark.selectedChestNumberItem,
      selectedMarkChestNumberColor1: state => state.mark.selectedChestNumberItemColor1,
      selectedMarkBack: state => state.mark.selectedBackItem,
      selectedMarkBackColor1: state => state.mark.selectedBackItemColor1,
      selectedMarkBackColor2: state => state.mark.selectedBackItemColor2,
      selectedMarkBackNumber: state => state.mark.selectedBackNumberItem,
      selectedMarkBackNumberColor1: state => state.mark.selectedBackNumberItemColor1,
      selectedMarkSleeve: state => state.mark.selectedSleeveItem,
      selectedMarkSleeveColor1: state => state.mark.selectedSleeveItemColor1,
    }),
    selectedEmblemImage: function() {
      return this.emblem.items.find(item => item.id === this.selectedEmblem.id)
    }
  },
  methods: {
    ...mapMutations({
      setTab: 'current/setTab'
    }),
    async print() {
      const el = this.$refs.canvas;
      const options = {
        type: 'dataURL',
        useCORS: true,
        imageTimeout: 100000000000000000000,
        allowTaint: true,
      }
      this.output = await this.$html2canvas(el, options);
      const link = document.createElement('a')
      link.href = this.output
      link.download = 'capture.jpg'
      link.click()
      link.remove()
    },
  }
}
</script> 